import { Serializable } from '../../../core/models/serializable';
import { EmailType } from '../../../shared/models/email-type.enum';
import { CustomerAgentSmsSetting } from './customer-agent-sms-setting';
import { CustomerAgentStatus } from './customer-agent-status.enum';
import { User } from './customer-moderation.model';
export class CustomerAgentDetailsModel
  implements Serializable<CustomerAgentDetailsModel>
{
  fromObject(object: any): CustomerAgentDetailsModel {
    Object.assign(this, object);
    this.smsSettings = {};

    if (object && object.smsSettings) {
      var keys = Object.keys(object.smsSettings);
      keys.forEach((k) => {
        let t = new CustomerAgentSmsSetting();
        t = t.fromObject(object.smsSettings[k]);
        this.smsSettings[k] = t;
      });
    }

    return this;
  }
  toObject() {
    let result = {
      CustomerId: this.customerId,
      CustomerAgentId: this.customerAgentId,
      Name: this.name,
      Surname: this.surname,
      Email: this.email,
      PhoneNumber: this.phoneNumber && this.phoneNumber.trim(),
      PhoneNumberExtension: this.phoneNumberExtension,
      MobilePhoneNumber: this.mobilePhoneNumber,
      MobilePhoneNumber2: this.mobilePhoneNumber2,
      IsProfileOwner: this.isProfileOwner,
      Position: this.position,
      StoppedEmails: this.stoppedEmails,
      SmsSettings: Object.values(this.smsSettings ?? {}).reduce((acc, s) => { 
        acc[s.smsTypeId] = s.toObject();
        return acc;
      }, {}),
      createDate: this.createDate,
      languageId: this.languageId,
    };
    return result;
  }
  public customerId: number;
  public customerAgentId: number;
  public name: string;
  public surname: string;
  public email: string;
  public phoneNumber: string;
  public phoneNumberExtension: string;
  public mobilePhoneNumber: string;
  public mobilePhoneNumber2: string;
  public statusId: number;
  public status: string;
  public isProfileOwner: boolean;
  public position: string;
  public createDate: string;
  public languageId: string;

  public stoppedEmails: EmailType[];
  public smsSettings: { [smsTypeId: number]: CustomerAgentSmsSetting };

  constructor() {
    this.stoppedEmails = [];
    this.smsSettings = {};
  }
}

export interface CustomerAgent {
  customerId: number;
  customerAgentId: number;
  name: string;
  surname: string;
  email: string;
  phoneNumber: string;
  phoneNumberExtension: string;
  mobilePhoneNumber: string;
  mobilePhoneNumber2: string;
  statusId: number;
  status: string;
  isProfileOwner: boolean;
  position: string;
  createDate: string;
  languageId: string;

  stoppedEmails: EmailType[];
  smsSettings: { [smsTypeId: number]: CustomerAgentSmsSetting };
}
